import { Box, Typography } from '@mui/material';

const vendorColorMap = {
  Jazz: '#EF4444',
  Wateen: '#2563EB',
  MPPL: '#8B5CF6',
  PTCL: '#10B981',
  WTL: '#F97316',
  Nayatel: '#CA8A04',
  Other: '#9CA3AF',
};

const VendorLegend = ({ network }) => {
  // Filter out JAZZ and WTL for FTTS network
  const getFilteredVendors = () => {
    if (network === 'FTTS') {
      const filtered = { ...vendorColorMap };
      delete filtered.Jazz;
      delete filtered.WTL;
      return filtered;
    }
    return vendorColorMap;
  };

  const filteredVendors = getFilteredVendors();

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        border: '1px solid #E0E0E0',
        borderRadius: '8px',
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
        padding: '12px 16px',
        minWidth: '200px',
      }}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
          marginBottom: '10px',
          color: '#000',
        }}
      >
        Vendor Legent
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {Object.entries(filteredVendors).map(([vendor, color]) => (
          <Box
            key={vendor}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <Box
              sx={{
                width: '16px',
                height: '16px',
                backgroundColor: color,
                borderRadius: '3px',
                border: '1px solid #E0E0E0',
                flexShrink: 0,
              }}
            />
            <Typography
              sx={{
                fontSize: '15px',
                color: '#000',
                fontWeight: 400,
              }}
            >
              {vendor}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default VendorLegend;
